import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-control-statements/jsx-use-if-tag */
import { useMemo } from 'react';
import { BLOCKS as B } from '@contentful/rich-text-types';
import { RichText } from '@uswitch/ev-core/react';
import { getVariantPath } from '@uswitch/ev-utils/get-variant-path';
import { toKebabCase } from '@uswitch/ev-utils/string';
import ICONS from '@uswitch/ev-utils/icons';
import richTextFieldHasContent from '@uswitch/ev-utils/rich-text/has-content';
import richTextStyles from '@uswitch/ev-utils/rich-text/styles';
import { List as SparkList, ListItem as SparkListItem } from '@uswitch/spark.list';
import { removeEmptyTextContent } from './utils';
import withComponentBase from '../../helpers/with-component-base';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var stylePath = function stylePath(field, variant) {
  return getVariantPath({
    atomicType: 'modules',
    componentId: 'checklist',
    variantName: variant,
    field: field
  });
};

var styles = {
  'h1,h2,h3,h4,h5,h6': {
    marginTop: 'sm'
  }
};

var parentContentTypeStyles = _objectSpread({
  textAlign: 'left',
  display: 'grid',
  width: 'auto'
}, styles);

var createOptionOverride = function createOptionOverride(iconName) {
  var _ICONS$toKebabCase, _ICONS$toKebabCase2, _renderNode;

  var icon = (_ICONS$toKebabCase = ICONS[toKebabCase(iconName)]) === null || _ICONS$toKebabCase === void 0 ? void 0 : _ICONS$toKebabCase.icon;
  var color = (_ICONS$toKebabCase2 = ICONS[toKebabCase(iconName)]) === null || _ICONS$toKebabCase2 === void 0 ? void 0 : _ICONS$toKebabCase2.color;
  return {
    renderNode: (_renderNode = {}, _defineProperty(_renderNode, B.UL_LIST, function (_, text) {
      return _jsx(SparkList, {
        children: text
      });
    }), _defineProperty(_renderNode, B.LIST_ITEM, function (_, text) {
      return removeEmptyTextContent(text).length ? _jsx(SparkListItem, {
        sx: {
          variant: stylePath('list-item', iconName)
        },
        icon: icon,
        iconColor: color,
        children: text
      }) : null;
    }), _renderNode)
  };
};

var Checklist = function Checklist(_ref) {
  var firstChecklistIcon = _ref.firstChecklistIcon,
      secondChecklistIcon = _ref.secondChecklistIcon,
      firstChecklist = _ref.firstChecklist,
      _ref$secondChecklist = _ref.secondChecklist,
      secondChecklist = _ref$secondChecklist === void 0 ? {} : _ref$secondChecklist,
      parentContentType = _ref.parentContentType;
  var firstOptionOverrides = useMemo(function () {
    return createOptionOverride(firstChecklistIcon);
  }, [firstChecklistIcon]);
  var secondOptionOverrides = useMemo(function () {
    return createOptionOverride(secondChecklistIcon);
  }, [secondChecklistIcon]);
  var secondChecklistExists = richTextFieldHasContent(secondChecklist);
  return _jsxs("div", {
    sx: _objectSpread(_objectSpread({
      gridTemplateColumns: parentContentType === 'richTextModule' ? ['1fr'] : ['1fr', "repeat(".concat(!secondChecklistExists ? 1 : 2, ",minmax(0,1fr))")]
    }, parentContentTypeStyles), {}, {
      variant: stylePath('container')
    }),
    children: [_jsx(RichText, {
      content: firstChecklist.content,
      optionOverrides: firstOptionOverrides,
      style: _objectSpread({
        variant: stylePath('list', firstChecklistIcon)
      }, richTextStyles)
    }), secondChecklistExists && _jsx(RichText, {
      content: secondChecklist === null || secondChecklist === void 0 ? void 0 : secondChecklist.content,
      optionOverrides: secondOptionOverrides,
      style: _objectSpread({
        variant: stylePath('list', secondChecklistIcon)
      }, richTextStyles)
    })]
  });
};

export default withComponentBase(Checklist, {
  withHeaderFooter: true
});
//# sourceMappingURL=index.js.map